
@if ((checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)) {
  <div class="inline-search-wrapper" (click)="addToInlineSearchProps({value:value})"></div>
}

<input [placeholder]="checkPlaceholder()"
  class="sem-text-box sem-iban" type="text"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
  (input)="onTextChange($event)"
  [(ngModel)]="value"
  [maxlength]="maxLengthInteger"
  [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>


  @if (showTooltipValue) {
    <span class="sem-text-box-tooltip">{{value}}</span>
  }

  <!-- *ngIf="!evaluateConditionForHiding(condition,model)" -->
  <p class="binding-prop-name">{{getAttribute('name')}}</p>